var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action",on:{"click":_vm.click}},[_c('i',{class:_vm.action.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.action.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }